var map = {
	"./advise.svg": 2468,
	"./all.svg": 8632,
	"./caption.svg": 5672,
	"./change-color.svg": 6692,
	"./close.svg": 3556,
	"./comment.svg": 7020,
	"./delete.svg": 496,
	"./diagnosis.svg": 2588,
	"./disease.svg": 9184,
	"./download.svg": 8452,
	"./history.svg": 3300,
	"./more.svg": 2480,
	"./ocr.svg": 4880,
	"./pdf-icon.png": 9448,
	"./print.svg": 5928,
	"./rename.svg": 6524,
	"./rx.svg": 52,
	"./upload-file-icon.svg": 3100,
	"./upload.svg": 4492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9868;